/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Finish_CtaInputs */

const en_funnel_finish_cta = /** @type {(inputs: Funnel_Finish_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free trial`)
};

const es_funnel_finish_cta = /** @type {(inputs: Funnel_Finish_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar prueba gratuita`)
};

/**
* | output |
* | --- |
* | "Start free trial" |
*
* @param {Funnel_Finish_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_finish_cta = /** @type {((inputs?: Funnel_Finish_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Finish_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_finish_cta(inputs)
	return en_funnel_finish_cta(inputs)
});